import { Store, _ } from 'utils';

class InfoStore extends Store {

	getInitialState() {
		return {
			visible: localStorage.getItem('infobox'),
			enabled: true,
		}
	}

	onInfoStatusChanged(state, data) {
		state.visible = data.visible;
		localStorage.setItem('infobox', data.visible);
	}

	onPavilionsChanged(state, data)
	{
		state.enabled = data.displayIntroText;
	}

	getContent() {
		return _('vdkz.intro');
	}

	isInfoVisible() {
		return this.getState().visible == null
	}
}

const store = new InfoStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/infostore.js